/* eslint-disable no-redeclare */
import useLocalStorage, { writeStorage } from '@rehooks/local-storage';
import { LocalStorageNullableReturnValue, LocalStorageReturnValue } from '@rehooks/local-storage/lib/use-localstorage';
import { ostroAdapter } from 'app/services/ostroAdapter';

// This is to allow type inference based on whether a defaultValue is provided:
// const [myValue] = useNamespacedLocalStorage('myKey') <-- myValue is of type string | null
// const [myValue] = useNamespacedLocalStorage('myKey', 'myDefaultValue') <-- myValue is of type string
// const [myNumbers] = useNamespacedLocalStorage<number[]>('myKey') <-- myNumbers is of type number[] | null
// const [myNumbers] = useNamespacedLocalStorage<number[]>('myKey', [1, 2]) <-- myNumbers is of type number[]
function useNamespacedLocalStorage<T = string>(key: string): LocalStorageNullableReturnValue<T>;
function useNamespacedLocalStorage<T = string>(key: string, defaultValue: T): LocalStorageReturnValue<T>;
function useNamespacedLocalStorage<T = string>(key: string, defaultValue: T | null = null) {
  const conditionId = ostroAdapter.getConditionId();
  return useLocalStorage<T | null>(`${key}-${conditionId}`, defaultValue ?? null);
}

export function getNamespacedLocalStorageKey(key: string) {
  const conditionId = ostroAdapter.getConditionId();
  return localStorage.getItem(`${key}-${conditionId}`);
}

export function setNamespacedLocalStorageKey<T = string>(key: string, value: T) {
  const conditionId = ostroAdapter.getConditionId();
  writeStorage(`${key}-${conditionId}`, value);
}

export default useNamespacedLocalStorage;
